import { render, staticRenderFns } from "./ExportarXML.vue?vue&type=template&id=252e1f22&"
import script from "./ExportarXML.vue?vue&type=script&lang=js&"
export * from "./ExportarXML.vue?vue&type=script&lang=js&"
import style0 from "./ExportarXML.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports